import { copy } from './copy';

export const sortDataFunction = (oldData, sortField, sortOrder) => {
  const data = copy(oldData);

  if (sortOrder === 'asc') {
    data.sort((a, b) => {
      if (a[sortField] === null || a[sortField] === undefined) {
        return 1;
      }
      if (b[sortField] === null || b[sortField] === undefined) {
        return -1;
      }
      return (a[sortField] < b[sortField] ? -1 : Number(a[sortField] !== b[sortField]));
    });
  } else {
    data.sort((a, b) => {
      if (a[sortField] === null || a[sortField] === undefined) {
        return 1;
      }
      if (b[sortField] === null || b[sortField] === undefined) {
        return -1;
      }
      return (a[sortField] < b[sortField] ? Number(a[sortField] !== b[sortField]) : -1);
    });
  }

  return data;
};

export default sortDataFunction;
